import { EntityModel, EntityInvitationModel } from "@jugl-web/rest-api";
import { createContext } from "react";

export interface EntitySelectPageContextValue {
  entitiesState: {
    isLoading: boolean;
    isError: boolean;
    isFetching: boolean;
    entities?: EntityModel[] | undefined;
  };
  entityInvitesState: {
    isLoading: boolean;
    isError: boolean;
    isFetching: boolean;
    entityInvites?: EntityInvitationModel[] | undefined;
  };
  refetchEntities: () => void;
  refetchEntityInvites: () => void;
}

export const EntitySelectPageContext =
  createContext<EntitySelectPageContextValue | null>(null);
